<template>
  <path
    d="M16.85 17.1502L18.29 15.7102L13.41 10.8302L10.12 14.1202C9.72998 14.5102 9.09998 14.5102 8.70998 14.1202L2.70998 8.11021C2.31998 7.72021 2.31998 7.09021 2.70998 6.70021C3.09998 6.31021 3.72998 6.31021 4.11998 6.70021L9.40998 12.0002L12.7 8.71022C13.09 8.32022 13.72 8.32022 14.11 8.71022L19.7 14.2902L21.14 12.8502C21.45 12.5402 21.99 12.7602 21.99 13.2002V17.4902C21.99 17.7702 21.77 17.9902 21.49 17.9902H17.2C16.76 18.0002 16.54 17.4602 16.85 17.1502Z"
  />
</template>
